import React from 'react';
import MatchFormPage from './MatchFormPage';
const EditMatchPage: React.FC = () => <MatchFormPage editing />;
export default EditMatchPage;
